<template>
  <div class="salaire-list">
    <!-- La barre d'action -->
    <PageHeader title="Histoire de salaire" :has-back="true" @back="goBack" />

    <!-- La liste des calculators -->
    <sortable-list :items="data" :parameters="listParameters"> </sortable-list>
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      data: [],
      listParameters: [
        {
          name: "Username",
          key: "username",
        },
        {
          name: "Dernière MAJ",
          key: "date_updated",
        },
        {
          name: "SMIC",
          key: "smic",
        },
        {
          name: "Coef 1 à 19",
          key: "coef1a19",
        },
        {
          name: "Coef 20 ou plus",
          key: "coef20plus",
        },
        {
          name: "Taux de charge",
          key: "taux_charge",
        },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push("/admin/calculators/salaire/list");
    },
  },
  mounted() {
    calculatorsModel.getHistorySalaire().then((data) => {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "Europe/Paris",
      };
      data.forEach(function(d, i) {
        d.date_updated = new Date(d.date_updated).toLocaleDateString(
          "fr-FR",
          options
        );
        data[i] = Object.assign({}, d, JSON.parse(d.old_data));
      });
      this.data = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.impot-revenu-list {
  .debug-log {
    max-height: 200px;
    overflow-y: scroll;
  }
}
</style>
